import { AuthGroup, authGroupSchema } from '@sophocles/entities/AuthGroup/authGroupRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_AUTH_GROUPS = 'RECEIVE_AUTH_GROUPS';
function receiveAuthGroups(json) {
  return {
    type: RECEIVE_AUTH_GROUPS,
    authGroups: mapListToRecords(json, AuthGroup),
  };
}

/* Request Actions */
// starter request
export const REQUEST_AUTH_GROUP = 'REQUEST_AUTH_GROUP';
function requestAuthGroup(authGroup_id) {
  return {
    type: REQUEST_AUTH_GROUP,
    authGroup_id,
  };
}

export const REQUEST_ALL_AUTH_GROUPS = 'REQUEST_ALL_AUTH_GROUPS';
function requestAllAuthGroups() {
  return {
    type: REQUEST_ALL_AUTH_GROUPS,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchAuthGroup(authGroup_id) {
  return dispatch => {
    dispatch(requestAuthGroup(authGroup_id));
    return apiClient
      .get(`/groups/${authGroup_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'authGroups', authGroupSchema))
      .then(json => dispatch(receiveAuthGroups(json.entities.authGroups)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_AUTH_GROUP)));
  };
}

export function fetchAllAuthGroups() {
  return dispatch => {
    dispatch(requestAllAuthGroups());
    return apiClient
      .get(`/groups/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'authGroups', authGroupSchema))
      .then(json => dispatch(receiveAuthGroups(json.entities.authGroups)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_AUTH_GROUPS)));
  };
}

/* Edit Actions */
export const EDIT_AUTH_GROUP = 'EDIT_AUTH_GROUP';
export function editAuthGroup(authGroup_id) {
  return {
    type: EDIT_AUTH_GROUP,
    authGroup: authGroup_id,
  };
}

export function patchAuthGroup(authGroup_id, values) {
  return dispatch => {
    dispatch(editAuthGroup(authGroup_id));
    return apiClient
      .patch(`/groups/${authGroup_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, authGroupSchema))
      .then(json => dispatch(receiveAuthGroups(json.entities.authGroups)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_AUTH_GROUP)));
  };
}

/* Create Actions */
export const CREATE_AUTH_GROUP = 'CREATE_AUTH_GROUP';
function sayCreateAuthGroup(values) {
  return {
    type: CREATE_AUTH_GROUP,
    values: values,
  };
}

export function createAuthGroup(values) {
  return dispatch => {
    dispatch(sayCreateAuthGroup(values));
    return apiClient
      .post(`/groups/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, authGroupSchema))
      .then(json => dispatch(receiveAuthGroups(json.entities.authGroups)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_AUTH_GROUP)));
  };
}

/* Delete Actions */
export const DELETE_AUTH_GROUP = 'DELETE_AUTH_GROUP';
function sayDeleteAuthGroup(authGroup_id) {
  return {
    type: DELETE_AUTH_GROUP,
    authGroup: authGroup_id,
  };
}

export function deleteAuthGroup(authGroup_id) {
  return dispatch =>
    apiClient
      .delete(`/groups/${authGroup_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteAuthGroup(authGroup_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_AUTH_GROUP)));
}
